import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _7b04f926 = () => interopDefault(import('../pages/competition.vue' /* webpackChunkName: "pages/competition" */))
const _f334fd00 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _2799f48e = () => interopDefault(import('../pages/error/index.vue' /* webpackChunkName: "pages/error/index" */))
const _6125ea70 = () => interopDefault(import('../pages/fatal-error/index.vue' /* webpackChunkName: "pages/fatal-error/index" */))
const _24cb6baa = () => interopDefault(import('../pages/leaderboard.vue' /* webpackChunkName: "pages/leaderboard" */))
const _096b1148 = () => interopDefault(import('../pages/my-clan/index.vue' /* webpackChunkName: "pages/my-clan/index" */))
const _12d562d9 = () => interopDefault(import('../pages/schedule.vue' /* webpackChunkName: "pages/schedule" */))
const _70cb0401 = () => interopDefault(import('../pages/my-clan/change-captain.vue' /* webpackChunkName: "pages/my-clan/change-captain" */))
const _cbf37c3a = () => interopDefault(import('../pages/my-clan/lock-roster.vue' /* webpackChunkName: "pages/my-clan/lock-roster" */))
const _e28bfb42 = () => interopDefault(import('../pages/my-clan/manage.vue' /* webpackChunkName: "pages/my-clan/manage" */))
const _52f36504 = () => interopDefault(import('../pages/my-clan/withdraw.vue' /* webpackChunkName: "pages/my-clan/withdraw" */))
const _189b65d8 = () => interopDefault(import('../pages/my-clan/china/wechat.vue' /* webpackChunkName: "pages/my-clan/china/wechat" */))
const _69cd35bc = () => interopDefault(import('../pages/registration/china/wechat.vue' /* webpackChunkName: "pages/registration/china/wechat" */))
const _014be833 = () => interopDefault(import('../pages/registration/feedback/account-creation-completed.vue' /* webpackChunkName: "pages/registration/feedback/account-creation-completed" */))
const _a6b05ac4 = () => interopDefault(import('../pages/registration/feedback/captain-pick-completed.vue' /* webpackChunkName: "pages/registration/feedback/captain-pick-completed" */))
const _e98b3cf6 = () => interopDefault(import('../pages/registration/profile/age.vue' /* webpackChunkName: "pages/registration/profile/age" */))
const _284ced34 = () => interopDefault(import('../pages/registration/profile/create.vue' /* webpackChunkName: "pages/registration/profile/create" */))
const _2a728235 = () => interopDefault(import('../pages/registration/profile/gate.vue' /* webpackChunkName: "pages/registration/profile/gate" */))
const _63ca9f89 = () => interopDefault(import('../pages/registration/profile/success.vue' /* webpackChunkName: "pages/registration/profile/success" */))
const _5caa6a63 = () => interopDefault(import('../pages/registration/profile/verify.vue' /* webpackChunkName: "pages/registration/profile/verify" */))
const _60b55032 = () => interopDefault(import('../pages/registration/team/invite.vue' /* webpackChunkName: "pages/registration/team/invite" */))
const _c0484b54 = () => interopDefault(import('../pages/registration/team/pick-captain.vue' /* webpackChunkName: "pages/registration/team/pick-captain" */))
const _26d6389e = () => interopDefault(import('../pages/my-clan/kick/_player.vue' /* webpackChunkName: "pages/my-clan/kick/_player" */))
const _1a092261 = () => interopDefault(import('../pages/error/_id.vue' /* webpackChunkName: "pages/error/_id" */))
const _5d34b0cc = () => interopDefault(import('../pages/fatal-error/_message.vue' /* webpackChunkName: "pages/fatal-error/_message" */))
const _11fdc5c4 = () => interopDefault(import('../pages/match/_id.vue' /* webpackChunkName: "pages/match/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/competition",
    component: _7b04f926,
    name: "competition___en___default"
  }, {
    path: "/de",
    component: _f334fd00,
    name: "index___de"
  }, {
    path: "/en",
    component: _f334fd00,
    name: "index___en"
  }, {
    path: "/error",
    component: _2799f48e,
    name: "error___en___default"
  }, {
    path: "/es",
    component: _f334fd00,
    name: "index___es"
  }, {
    path: "/fatal-error",
    component: _6125ea70,
    name: "fatal-error___en___default"
  }, {
    path: "/fr",
    component: _f334fd00,
    name: "index___fr"
  }, {
    path: "/it",
    component: _f334fd00,
    name: "index___it"
  }, {
    path: "/jp",
    component: _f334fd00,
    name: "index___jp"
  }, {
    path: "/ko",
    component: _f334fd00,
    name: "index___ko"
  }, {
    path: "/leaderboard",
    component: _24cb6baa,
    name: "leaderboard___en___default"
  }, {
    path: "/my-clan",
    component: _096b1148,
    name: "my-clan___en___default"
  }, {
    path: "/pt",
    component: _f334fd00,
    name: "index___pt"
  }, {
    path: "/schedule",
    component: _12d562d9,
    name: "schedule___en___default"
  }, {
    path: "/zh_TW",
    component: _f334fd00,
    name: "index___zh_TW"
  }, {
    path: "/de/competition",
    component: _7b04f926,
    name: "competition___de"
  }, {
    path: "/de/error",
    component: _2799f48e,
    name: "error___de"
  }, {
    path: "/de/fatal-error",
    component: _6125ea70,
    name: "fatal-error___de"
  }, {
    path: "/de/leaderboard",
    component: _24cb6baa,
    name: "leaderboard___de"
  }, {
    path: "/de/my-clan",
    component: _096b1148,
    name: "my-clan___de"
  }, {
    path: "/de/schedule",
    component: _12d562d9,
    name: "schedule___de"
  }, {
    path: "/en/competition",
    component: _7b04f926,
    name: "competition___en"
  }, {
    path: "/en/error",
    component: _2799f48e,
    name: "error___en"
  }, {
    path: "/en/fatal-error",
    component: _6125ea70,
    name: "fatal-error___en"
  }, {
    path: "/en/leaderboard",
    component: _24cb6baa,
    name: "leaderboard___en"
  }, {
    path: "/en/my-clan",
    component: _096b1148,
    name: "my-clan___en"
  }, {
    path: "/en/schedule",
    component: _12d562d9,
    name: "schedule___en"
  }, {
    path: "/es/competition",
    component: _7b04f926,
    name: "competition___es"
  }, {
    path: "/es/error",
    component: _2799f48e,
    name: "error___es"
  }, {
    path: "/es/fatal-error",
    component: _6125ea70,
    name: "fatal-error___es"
  }, {
    path: "/es/leaderboard",
    component: _24cb6baa,
    name: "leaderboard___es"
  }, {
    path: "/es/my-clan",
    component: _096b1148,
    name: "my-clan___es"
  }, {
    path: "/es/schedule",
    component: _12d562d9,
    name: "schedule___es"
  }, {
    path: "/fr/competition",
    component: _7b04f926,
    name: "competition___fr"
  }, {
    path: "/fr/error",
    component: _2799f48e,
    name: "error___fr"
  }, {
    path: "/fr/fatal-error",
    component: _6125ea70,
    name: "fatal-error___fr"
  }, {
    path: "/fr/leaderboard",
    component: _24cb6baa,
    name: "leaderboard___fr"
  }, {
    path: "/fr/my-clan",
    component: _096b1148,
    name: "my-clan___fr"
  }, {
    path: "/fr/schedule",
    component: _12d562d9,
    name: "schedule___fr"
  }, {
    path: "/it/competition",
    component: _7b04f926,
    name: "competition___it"
  }, {
    path: "/it/error",
    component: _2799f48e,
    name: "error___it"
  }, {
    path: "/it/fatal-error",
    component: _6125ea70,
    name: "fatal-error___it"
  }, {
    path: "/it/leaderboard",
    component: _24cb6baa,
    name: "leaderboard___it"
  }, {
    path: "/it/my-clan",
    component: _096b1148,
    name: "my-clan___it"
  }, {
    path: "/it/schedule",
    component: _12d562d9,
    name: "schedule___it"
  }, {
    path: "/jp/competition",
    component: _7b04f926,
    name: "competition___jp"
  }, {
    path: "/jp/error",
    component: _2799f48e,
    name: "error___jp"
  }, {
    path: "/jp/fatal-error",
    component: _6125ea70,
    name: "fatal-error___jp"
  }, {
    path: "/jp/leaderboard",
    component: _24cb6baa,
    name: "leaderboard___jp"
  }, {
    path: "/jp/my-clan",
    component: _096b1148,
    name: "my-clan___jp"
  }, {
    path: "/jp/schedule",
    component: _12d562d9,
    name: "schedule___jp"
  }, {
    path: "/ko/competition",
    component: _7b04f926,
    name: "competition___ko"
  }, {
    path: "/ko/error",
    component: _2799f48e,
    name: "error___ko"
  }, {
    path: "/ko/fatal-error",
    component: _6125ea70,
    name: "fatal-error___ko"
  }, {
    path: "/ko/leaderboard",
    component: _24cb6baa,
    name: "leaderboard___ko"
  }, {
    path: "/ko/my-clan",
    component: _096b1148,
    name: "my-clan___ko"
  }, {
    path: "/ko/schedule",
    component: _12d562d9,
    name: "schedule___ko"
  }, {
    path: "/my-clan/change-captain",
    component: _70cb0401,
    name: "my-clan-change-captain___en___default"
  }, {
    path: "/my-clan/lock-roster",
    component: _cbf37c3a,
    name: "my-clan-lock-roster___en___default"
  }, {
    path: "/my-clan/manage",
    component: _e28bfb42,
    name: "my-clan-manage___en___default"
  }, {
    path: "/my-clan/withdraw",
    component: _52f36504,
    name: "my-clan-withdraw___en___default"
  }, {
    path: "/pt/competition",
    component: _7b04f926,
    name: "competition___pt"
  }, {
    path: "/pt/error",
    component: _2799f48e,
    name: "error___pt"
  }, {
    path: "/pt/fatal-error",
    component: _6125ea70,
    name: "fatal-error___pt"
  }, {
    path: "/pt/leaderboard",
    component: _24cb6baa,
    name: "leaderboard___pt"
  }, {
    path: "/pt/my-clan",
    component: _096b1148,
    name: "my-clan___pt"
  }, {
    path: "/pt/schedule",
    component: _12d562d9,
    name: "schedule___pt"
  }, {
    path: "/zh_TW/competition",
    component: _7b04f926,
    name: "competition___zh_TW"
  }, {
    path: "/zh_TW/error",
    component: _2799f48e,
    name: "error___zh_TW"
  }, {
    path: "/zh_TW/fatal-error",
    component: _6125ea70,
    name: "fatal-error___zh_TW"
  }, {
    path: "/zh_TW/leaderboard",
    component: _24cb6baa,
    name: "leaderboard___zh_TW"
  }, {
    path: "/zh_TW/my-clan",
    component: _096b1148,
    name: "my-clan___zh_TW"
  }, {
    path: "/zh_TW/schedule",
    component: _12d562d9,
    name: "schedule___zh_TW"
  }, {
    path: "/de/my-clan/change-captain",
    component: _70cb0401,
    name: "my-clan-change-captain___de"
  }, {
    path: "/de/my-clan/lock-roster",
    component: _cbf37c3a,
    name: "my-clan-lock-roster___de"
  }, {
    path: "/de/my-clan/manage",
    component: _e28bfb42,
    name: "my-clan-manage___de"
  }, {
    path: "/de/my-clan/withdraw",
    component: _52f36504,
    name: "my-clan-withdraw___de"
  }, {
    path: "/en/my-clan/change-captain",
    component: _70cb0401,
    name: "my-clan-change-captain___en"
  }, {
    path: "/en/my-clan/lock-roster",
    component: _cbf37c3a,
    name: "my-clan-lock-roster___en"
  }, {
    path: "/en/my-clan/manage",
    component: _e28bfb42,
    name: "my-clan-manage___en"
  }, {
    path: "/en/my-clan/withdraw",
    component: _52f36504,
    name: "my-clan-withdraw___en"
  }, {
    path: "/es/my-clan/change-captain",
    component: _70cb0401,
    name: "my-clan-change-captain___es"
  }, {
    path: "/es/my-clan/lock-roster",
    component: _cbf37c3a,
    name: "my-clan-lock-roster___es"
  }, {
    path: "/es/my-clan/manage",
    component: _e28bfb42,
    name: "my-clan-manage___es"
  }, {
    path: "/es/my-clan/withdraw",
    component: _52f36504,
    name: "my-clan-withdraw___es"
  }, {
    path: "/fr/my-clan/change-captain",
    component: _70cb0401,
    name: "my-clan-change-captain___fr"
  }, {
    path: "/fr/my-clan/lock-roster",
    component: _cbf37c3a,
    name: "my-clan-lock-roster___fr"
  }, {
    path: "/fr/my-clan/manage",
    component: _e28bfb42,
    name: "my-clan-manage___fr"
  }, {
    path: "/fr/my-clan/withdraw",
    component: _52f36504,
    name: "my-clan-withdraw___fr"
  }, {
    path: "/it/my-clan/change-captain",
    component: _70cb0401,
    name: "my-clan-change-captain___it"
  }, {
    path: "/it/my-clan/lock-roster",
    component: _cbf37c3a,
    name: "my-clan-lock-roster___it"
  }, {
    path: "/it/my-clan/manage",
    component: _e28bfb42,
    name: "my-clan-manage___it"
  }, {
    path: "/it/my-clan/withdraw",
    component: _52f36504,
    name: "my-clan-withdraw___it"
  }, {
    path: "/jp/my-clan/change-captain",
    component: _70cb0401,
    name: "my-clan-change-captain___jp"
  }, {
    path: "/jp/my-clan/lock-roster",
    component: _cbf37c3a,
    name: "my-clan-lock-roster___jp"
  }, {
    path: "/jp/my-clan/manage",
    component: _e28bfb42,
    name: "my-clan-manage___jp"
  }, {
    path: "/jp/my-clan/withdraw",
    component: _52f36504,
    name: "my-clan-withdraw___jp"
  }, {
    path: "/ko/my-clan/change-captain",
    component: _70cb0401,
    name: "my-clan-change-captain___ko"
  }, {
    path: "/ko/my-clan/lock-roster",
    component: _cbf37c3a,
    name: "my-clan-lock-roster___ko"
  }, {
    path: "/ko/my-clan/manage",
    component: _e28bfb42,
    name: "my-clan-manage___ko"
  }, {
    path: "/ko/my-clan/withdraw",
    component: _52f36504,
    name: "my-clan-withdraw___ko"
  }, {
    path: "/my-clan/china/wechat",
    component: _189b65d8,
    name: "my-clan-china-wechat___en___default"
  }, {
    path: "/pt/my-clan/change-captain",
    component: _70cb0401,
    name: "my-clan-change-captain___pt"
  }, {
    path: "/pt/my-clan/lock-roster",
    component: _cbf37c3a,
    name: "my-clan-lock-roster___pt"
  }, {
    path: "/pt/my-clan/manage",
    component: _e28bfb42,
    name: "my-clan-manage___pt"
  }, {
    path: "/pt/my-clan/withdraw",
    component: _52f36504,
    name: "my-clan-withdraw___pt"
  }, {
    path: "/registration/china/wechat",
    component: _69cd35bc,
    name: "registration-china-wechat___en___default"
  }, {
    path: "/registration/feedback/account-creation-completed",
    component: _014be833,
    name: "registration-feedback-account-creation-completed___en___default"
  }, {
    path: "/registration/feedback/captain-pick-completed",
    component: _a6b05ac4,
    name: "registration-feedback-captain-pick-completed___en___default"
  }, {
    path: "/registration/profile/age",
    component: _e98b3cf6,
    name: "registration-profile-age___en___default"
  }, {
    path: "/registration/profile/create",
    component: _284ced34,
    name: "registration-profile-create___en___default"
  }, {
    path: "/registration/profile/gate",
    component: _2a728235,
    name: "registration-profile-gate___en___default"
  }, {
    path: "/registration/profile/success",
    component: _63ca9f89,
    name: "registration-profile-success___en___default"
  }, {
    path: "/registration/profile/verify",
    component: _5caa6a63,
    name: "registration-profile-verify___en___default"
  }, {
    path: "/registration/team/invite",
    component: _60b55032,
    name: "registration-team-invite___en___default"
  }, {
    path: "/registration/team/pick-captain",
    component: _c0484b54,
    name: "registration-team-pick-captain___en___default"
  }, {
    path: "/zh_TW/my-clan/change-captain",
    component: _70cb0401,
    name: "my-clan-change-captain___zh_TW"
  }, {
    path: "/zh_TW/my-clan/lock-roster",
    component: _cbf37c3a,
    name: "my-clan-lock-roster___zh_TW"
  }, {
    path: "/zh_TW/my-clan/manage",
    component: _e28bfb42,
    name: "my-clan-manage___zh_TW"
  }, {
    path: "/zh_TW/my-clan/withdraw",
    component: _52f36504,
    name: "my-clan-withdraw___zh_TW"
  }, {
    path: "/de/my-clan/china/wechat",
    component: _189b65d8,
    name: "my-clan-china-wechat___de"
  }, {
    path: "/de/registration/china/wechat",
    component: _69cd35bc,
    name: "registration-china-wechat___de"
  }, {
    path: "/de/registration/feedback/account-creation-completed",
    component: _014be833,
    name: "registration-feedback-account-creation-completed___de"
  }, {
    path: "/de/registration/feedback/captain-pick-completed",
    component: _a6b05ac4,
    name: "registration-feedback-captain-pick-completed___de"
  }, {
    path: "/de/registration/profile/age",
    component: _e98b3cf6,
    name: "registration-profile-age___de"
  }, {
    path: "/de/registration/profile/create",
    component: _284ced34,
    name: "registration-profile-create___de"
  }, {
    path: "/de/registration/profile/gate",
    component: _2a728235,
    name: "registration-profile-gate___de"
  }, {
    path: "/de/registration/profile/success",
    component: _63ca9f89,
    name: "registration-profile-success___de"
  }, {
    path: "/de/registration/profile/verify",
    component: _5caa6a63,
    name: "registration-profile-verify___de"
  }, {
    path: "/de/registration/team/invite",
    component: _60b55032,
    name: "registration-team-invite___de"
  }, {
    path: "/de/registration/team/pick-captain",
    component: _c0484b54,
    name: "registration-team-pick-captain___de"
  }, {
    path: "/en/my-clan/china/wechat",
    component: _189b65d8,
    name: "my-clan-china-wechat___en"
  }, {
    path: "/en/registration/china/wechat",
    component: _69cd35bc,
    name: "registration-china-wechat___en"
  }, {
    path: "/en/registration/feedback/account-creation-completed",
    component: _014be833,
    name: "registration-feedback-account-creation-completed___en"
  }, {
    path: "/en/registration/feedback/captain-pick-completed",
    component: _a6b05ac4,
    name: "registration-feedback-captain-pick-completed___en"
  }, {
    path: "/en/registration/profile/age",
    component: _e98b3cf6,
    name: "registration-profile-age___en"
  }, {
    path: "/en/registration/profile/create",
    component: _284ced34,
    name: "registration-profile-create___en"
  }, {
    path: "/en/registration/profile/gate",
    component: _2a728235,
    name: "registration-profile-gate___en"
  }, {
    path: "/en/registration/profile/success",
    component: _63ca9f89,
    name: "registration-profile-success___en"
  }, {
    path: "/en/registration/profile/verify",
    component: _5caa6a63,
    name: "registration-profile-verify___en"
  }, {
    path: "/en/registration/team/invite",
    component: _60b55032,
    name: "registration-team-invite___en"
  }, {
    path: "/en/registration/team/pick-captain",
    component: _c0484b54,
    name: "registration-team-pick-captain___en"
  }, {
    path: "/es/my-clan/china/wechat",
    component: _189b65d8,
    name: "my-clan-china-wechat___es"
  }, {
    path: "/es/registration/china/wechat",
    component: _69cd35bc,
    name: "registration-china-wechat___es"
  }, {
    path: "/es/registration/feedback/account-creation-completed",
    component: _014be833,
    name: "registration-feedback-account-creation-completed___es"
  }, {
    path: "/es/registration/feedback/captain-pick-completed",
    component: _a6b05ac4,
    name: "registration-feedback-captain-pick-completed___es"
  }, {
    path: "/es/registration/profile/age",
    component: _e98b3cf6,
    name: "registration-profile-age___es"
  }, {
    path: "/es/registration/profile/create",
    component: _284ced34,
    name: "registration-profile-create___es"
  }, {
    path: "/es/registration/profile/gate",
    component: _2a728235,
    name: "registration-profile-gate___es"
  }, {
    path: "/es/registration/profile/success",
    component: _63ca9f89,
    name: "registration-profile-success___es"
  }, {
    path: "/es/registration/profile/verify",
    component: _5caa6a63,
    name: "registration-profile-verify___es"
  }, {
    path: "/es/registration/team/invite",
    component: _60b55032,
    name: "registration-team-invite___es"
  }, {
    path: "/es/registration/team/pick-captain",
    component: _c0484b54,
    name: "registration-team-pick-captain___es"
  }, {
    path: "/fr/my-clan/china/wechat",
    component: _189b65d8,
    name: "my-clan-china-wechat___fr"
  }, {
    path: "/fr/registration/china/wechat",
    component: _69cd35bc,
    name: "registration-china-wechat___fr"
  }, {
    path: "/fr/registration/feedback/account-creation-completed",
    component: _014be833,
    name: "registration-feedback-account-creation-completed___fr"
  }, {
    path: "/fr/registration/feedback/captain-pick-completed",
    component: _a6b05ac4,
    name: "registration-feedback-captain-pick-completed___fr"
  }, {
    path: "/fr/registration/profile/age",
    component: _e98b3cf6,
    name: "registration-profile-age___fr"
  }, {
    path: "/fr/registration/profile/create",
    component: _284ced34,
    name: "registration-profile-create___fr"
  }, {
    path: "/fr/registration/profile/gate",
    component: _2a728235,
    name: "registration-profile-gate___fr"
  }, {
    path: "/fr/registration/profile/success",
    component: _63ca9f89,
    name: "registration-profile-success___fr"
  }, {
    path: "/fr/registration/profile/verify",
    component: _5caa6a63,
    name: "registration-profile-verify___fr"
  }, {
    path: "/fr/registration/team/invite",
    component: _60b55032,
    name: "registration-team-invite___fr"
  }, {
    path: "/fr/registration/team/pick-captain",
    component: _c0484b54,
    name: "registration-team-pick-captain___fr"
  }, {
    path: "/it/my-clan/china/wechat",
    component: _189b65d8,
    name: "my-clan-china-wechat___it"
  }, {
    path: "/it/registration/china/wechat",
    component: _69cd35bc,
    name: "registration-china-wechat___it"
  }, {
    path: "/it/registration/feedback/account-creation-completed",
    component: _014be833,
    name: "registration-feedback-account-creation-completed___it"
  }, {
    path: "/it/registration/feedback/captain-pick-completed",
    component: _a6b05ac4,
    name: "registration-feedback-captain-pick-completed___it"
  }, {
    path: "/it/registration/profile/age",
    component: _e98b3cf6,
    name: "registration-profile-age___it"
  }, {
    path: "/it/registration/profile/create",
    component: _284ced34,
    name: "registration-profile-create___it"
  }, {
    path: "/it/registration/profile/gate",
    component: _2a728235,
    name: "registration-profile-gate___it"
  }, {
    path: "/it/registration/profile/success",
    component: _63ca9f89,
    name: "registration-profile-success___it"
  }, {
    path: "/it/registration/profile/verify",
    component: _5caa6a63,
    name: "registration-profile-verify___it"
  }, {
    path: "/it/registration/team/invite",
    component: _60b55032,
    name: "registration-team-invite___it"
  }, {
    path: "/it/registration/team/pick-captain",
    component: _c0484b54,
    name: "registration-team-pick-captain___it"
  }, {
    path: "/jp/my-clan/china/wechat",
    component: _189b65d8,
    name: "my-clan-china-wechat___jp"
  }, {
    path: "/jp/registration/china/wechat",
    component: _69cd35bc,
    name: "registration-china-wechat___jp"
  }, {
    path: "/jp/registration/feedback/account-creation-completed",
    component: _014be833,
    name: "registration-feedback-account-creation-completed___jp"
  }, {
    path: "/jp/registration/feedback/captain-pick-completed",
    component: _a6b05ac4,
    name: "registration-feedback-captain-pick-completed___jp"
  }, {
    path: "/jp/registration/profile/age",
    component: _e98b3cf6,
    name: "registration-profile-age___jp"
  }, {
    path: "/jp/registration/profile/create",
    component: _284ced34,
    name: "registration-profile-create___jp"
  }, {
    path: "/jp/registration/profile/gate",
    component: _2a728235,
    name: "registration-profile-gate___jp"
  }, {
    path: "/jp/registration/profile/success",
    component: _63ca9f89,
    name: "registration-profile-success___jp"
  }, {
    path: "/jp/registration/profile/verify",
    component: _5caa6a63,
    name: "registration-profile-verify___jp"
  }, {
    path: "/jp/registration/team/invite",
    component: _60b55032,
    name: "registration-team-invite___jp"
  }, {
    path: "/jp/registration/team/pick-captain",
    component: _c0484b54,
    name: "registration-team-pick-captain___jp"
  }, {
    path: "/ko/my-clan/china/wechat",
    component: _189b65d8,
    name: "my-clan-china-wechat___ko"
  }, {
    path: "/ko/registration/china/wechat",
    component: _69cd35bc,
    name: "registration-china-wechat___ko"
  }, {
    path: "/ko/registration/feedback/account-creation-completed",
    component: _014be833,
    name: "registration-feedback-account-creation-completed___ko"
  }, {
    path: "/ko/registration/feedback/captain-pick-completed",
    component: _a6b05ac4,
    name: "registration-feedback-captain-pick-completed___ko"
  }, {
    path: "/ko/registration/profile/age",
    component: _e98b3cf6,
    name: "registration-profile-age___ko"
  }, {
    path: "/ko/registration/profile/create",
    component: _284ced34,
    name: "registration-profile-create___ko"
  }, {
    path: "/ko/registration/profile/gate",
    component: _2a728235,
    name: "registration-profile-gate___ko"
  }, {
    path: "/ko/registration/profile/success",
    component: _63ca9f89,
    name: "registration-profile-success___ko"
  }, {
    path: "/ko/registration/profile/verify",
    component: _5caa6a63,
    name: "registration-profile-verify___ko"
  }, {
    path: "/ko/registration/team/invite",
    component: _60b55032,
    name: "registration-team-invite___ko"
  }, {
    path: "/ko/registration/team/pick-captain",
    component: _c0484b54,
    name: "registration-team-pick-captain___ko"
  }, {
    path: "/pt/my-clan/china/wechat",
    component: _189b65d8,
    name: "my-clan-china-wechat___pt"
  }, {
    path: "/pt/registration/china/wechat",
    component: _69cd35bc,
    name: "registration-china-wechat___pt"
  }, {
    path: "/pt/registration/feedback/account-creation-completed",
    component: _014be833,
    name: "registration-feedback-account-creation-completed___pt"
  }, {
    path: "/pt/registration/feedback/captain-pick-completed",
    component: _a6b05ac4,
    name: "registration-feedback-captain-pick-completed___pt"
  }, {
    path: "/pt/registration/profile/age",
    component: _e98b3cf6,
    name: "registration-profile-age___pt"
  }, {
    path: "/pt/registration/profile/create",
    component: _284ced34,
    name: "registration-profile-create___pt"
  }, {
    path: "/pt/registration/profile/gate",
    component: _2a728235,
    name: "registration-profile-gate___pt"
  }, {
    path: "/pt/registration/profile/success",
    component: _63ca9f89,
    name: "registration-profile-success___pt"
  }, {
    path: "/pt/registration/profile/verify",
    component: _5caa6a63,
    name: "registration-profile-verify___pt"
  }, {
    path: "/pt/registration/team/invite",
    component: _60b55032,
    name: "registration-team-invite___pt"
  }, {
    path: "/pt/registration/team/pick-captain",
    component: _c0484b54,
    name: "registration-team-pick-captain___pt"
  }, {
    path: "/zh_TW/my-clan/china/wechat",
    component: _189b65d8,
    name: "my-clan-china-wechat___zh_TW"
  }, {
    path: "/zh_TW/registration/china/wechat",
    component: _69cd35bc,
    name: "registration-china-wechat___zh_TW"
  }, {
    path: "/zh_TW/registration/feedback/account-creation-completed",
    component: _014be833,
    name: "registration-feedback-account-creation-completed___zh_TW"
  }, {
    path: "/zh_TW/registration/feedback/captain-pick-completed",
    component: _a6b05ac4,
    name: "registration-feedback-captain-pick-completed___zh_TW"
  }, {
    path: "/zh_TW/registration/profile/age",
    component: _e98b3cf6,
    name: "registration-profile-age___zh_TW"
  }, {
    path: "/zh_TW/registration/profile/create",
    component: _284ced34,
    name: "registration-profile-create___zh_TW"
  }, {
    path: "/zh_TW/registration/profile/gate",
    component: _2a728235,
    name: "registration-profile-gate___zh_TW"
  }, {
    path: "/zh_TW/registration/profile/success",
    component: _63ca9f89,
    name: "registration-profile-success___zh_TW"
  }, {
    path: "/zh_TW/registration/profile/verify",
    component: _5caa6a63,
    name: "registration-profile-verify___zh_TW"
  }, {
    path: "/zh_TW/registration/team/invite",
    component: _60b55032,
    name: "registration-team-invite___zh_TW"
  }, {
    path: "/zh_TW/registration/team/pick-captain",
    component: _c0484b54,
    name: "registration-team-pick-captain___zh_TW"
  }, {
    path: "/",
    component: _f334fd00,
    name: "index___en___default"
  }, {
    path: "/de/my-clan/kick/:player",
    component: _26d6389e,
    name: "my-clan-kick-player___de"
  }, {
    path: "/en/my-clan/kick/:player",
    component: _26d6389e,
    name: "my-clan-kick-player___en"
  }, {
    path: "/es/my-clan/kick/:player",
    component: _26d6389e,
    name: "my-clan-kick-player___es"
  }, {
    path: "/fr/my-clan/kick/:player",
    component: _26d6389e,
    name: "my-clan-kick-player___fr"
  }, {
    path: "/it/my-clan/kick/:player",
    component: _26d6389e,
    name: "my-clan-kick-player___it"
  }, {
    path: "/jp/my-clan/kick/:player",
    component: _26d6389e,
    name: "my-clan-kick-player___jp"
  }, {
    path: "/ko/my-clan/kick/:player",
    component: _26d6389e,
    name: "my-clan-kick-player___ko"
  }, {
    path: "/pt/my-clan/kick/:player",
    component: _26d6389e,
    name: "my-clan-kick-player___pt"
  }, {
    path: "/zh_TW/my-clan/kick/:player",
    component: _26d6389e,
    name: "my-clan-kick-player___zh_TW"
  }, {
    path: "/de/error/:id",
    component: _1a092261,
    name: "error-id___de"
  }, {
    path: "/de/fatal-error/:message?",
    component: _5d34b0cc,
    name: "fatal-error-message___de"
  }, {
    path: "/de/match/:id?",
    component: _11fdc5c4,
    name: "match-id___de"
  }, {
    path: "/en/error/:id",
    component: _1a092261,
    name: "error-id___en"
  }, {
    path: "/en/fatal-error/:message?",
    component: _5d34b0cc,
    name: "fatal-error-message___en"
  }, {
    path: "/en/match/:id?",
    component: _11fdc5c4,
    name: "match-id___en"
  }, {
    path: "/es/error/:id",
    component: _1a092261,
    name: "error-id___es"
  }, {
    path: "/es/fatal-error/:message?",
    component: _5d34b0cc,
    name: "fatal-error-message___es"
  }, {
    path: "/es/match/:id?",
    component: _11fdc5c4,
    name: "match-id___es"
  }, {
    path: "/fr/error/:id",
    component: _1a092261,
    name: "error-id___fr"
  }, {
    path: "/fr/fatal-error/:message?",
    component: _5d34b0cc,
    name: "fatal-error-message___fr"
  }, {
    path: "/fr/match/:id?",
    component: _11fdc5c4,
    name: "match-id___fr"
  }, {
    path: "/it/error/:id",
    component: _1a092261,
    name: "error-id___it"
  }, {
    path: "/it/fatal-error/:message?",
    component: _5d34b0cc,
    name: "fatal-error-message___it"
  }, {
    path: "/it/match/:id?",
    component: _11fdc5c4,
    name: "match-id___it"
  }, {
    path: "/jp/error/:id",
    component: _1a092261,
    name: "error-id___jp"
  }, {
    path: "/jp/fatal-error/:message?",
    component: _5d34b0cc,
    name: "fatal-error-message___jp"
  }, {
    path: "/jp/match/:id?",
    component: _11fdc5c4,
    name: "match-id___jp"
  }, {
    path: "/ko/error/:id",
    component: _1a092261,
    name: "error-id___ko"
  }, {
    path: "/ko/fatal-error/:message?",
    component: _5d34b0cc,
    name: "fatal-error-message___ko"
  }, {
    path: "/ko/match/:id?",
    component: _11fdc5c4,
    name: "match-id___ko"
  }, {
    path: "/my-clan/kick/:player",
    component: _26d6389e,
    name: "my-clan-kick-player___en___default"
  }, {
    path: "/pt/error/:id",
    component: _1a092261,
    name: "error-id___pt"
  }, {
    path: "/pt/fatal-error/:message?",
    component: _5d34b0cc,
    name: "fatal-error-message___pt"
  }, {
    path: "/pt/match/:id?",
    component: _11fdc5c4,
    name: "match-id___pt"
  }, {
    path: "/zh_TW/error/:id",
    component: _1a092261,
    name: "error-id___zh_TW"
  }, {
    path: "/zh_TW/fatal-error/:message?",
    component: _5d34b0cc,
    name: "fatal-error-message___zh_TW"
  }, {
    path: "/zh_TW/match/:id?",
    component: _11fdc5c4,
    name: "match-id___zh_TW"
  }, {
    path: "/error/:id",
    component: _1a092261,
    name: "error-id___en___default"
  }, {
    path: "/fatal-error/:message?",
    component: _5d34b0cc,
    name: "fatal-error-message___en___default"
  }, {
    path: "/match/:id?",
    component: _11fdc5c4,
    name: "match-id___en___default"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
